import { Link } from "gatsby"
import React from "react"
import { Nav, Navbar } from "react-bootstrap"
import logo from "../images/logo.svg"
import "./design.scss"
import { useTranslation } from "react-i18next"

export function Header() {
  const { t } = useTranslation()

  return (
    <div>
      <Navbar className="scrolled" expand="lg">
        <Link to="/" className="navbar-brand ">
          <img
            src={logo}
            width="64"
            height="60"
            className="d-inline-block align-top"
            alt="React Bootstrap logo"
          />
        </Link>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ml-auto ">
            <Link to="/iframe?link=https://tabea659854.typeform.com/to/lD69PD33">
              {t("Become an Ambassador")}
            </Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
      <div>
        <div className="overlay"></div>
      </div>
    </div>
  )
}

export default Header
